<p-toast position="top-right" key="global"></p-toast>
<div *ngIf="routingEnable">
  <router-outlet></router-outlet>
</div>

<div *ngIf="registrationEnable">
  <app-schoolregistration></app-schoolregistration>
  
</div>
<div *ngIf="newRegistration">
  <app-new-school-registration></app-new-school-registration>
</div>

<div *ngIf="newLogin">
  <app-new-login></app-new-login>
</div>